import React, { useEffect, useState } from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom";

import blogs from "./data/blogs";
import BlogImage from "./BlogImage";

import "./blog.css";
import { BouncingLoader } from "../../pure-components/Loader";
import axios from "axios";

const BlogDetail = () => {
  const { slug } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [blog, setBlog] = useState(null);

  useEffect(() => {
        loadBlog(slug);
    },[])

const loadBlog = async (slugId = null) => {
    if (!slugId) return;

    setLoading(true);

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL || "";
      const url = `${baseUrl}api/blog/slug/${slugId}`;

    const response = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      })

    //   console.log("Blog response : ", response);
      if (!response.data.success) {
        throw new Error(`Error loading Blog`);
      }

      setBlog(response?.data?.data ?? null);
    } catch (error) {
      console.error("Failed to load blog:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!blog && !loading) {
    return (
      <div className="not-found flex flex-col blog-detail justify-center items-center mt-40">
        <h1>Article not found</h1>

        <button
        className="back-button"
          onClick={() => history.push("/blogs")}
        >
          ← Back to articles
        </button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="loading flex justify-center mt-40">
        <BouncingLoader />
      </div>
    );
  }
  return (
    <main className="blog-detail"  style={{ marginTop: "50px" }}>

      <button
        className="back-button"
        onClick={() => history.goBack()}
      >
        ← Back
      </button>

      <div className={`detail-category article-category ${blog.color || "pink"}`}>
        {blog.category}
      </div>

      <h1>{blog.title}</h1>

      <div className="detail-meta">
        {blog.date} · {blog.readTime}
      </div>

      <div className="detail-hero">
        <BlogImage
          src={blog.image}
          alt={blog.title}
          color={blog.color}
        />
      </div>

      <article className="detail-content">

        <p className="intro">
          {blog.description}
        </p>

        {blog.readText?.length > 0 && blog.readText.map((text, index) => (
          <div
            className="read-text"
            key={index}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        ))}

      </article>

    </main>
  );
};

export default BlogDetail;